import { render, staticRenderFns } from "./CategoryForumModal.vue?vue&type=template&id=1c77528b&"
import script from "./CategoryForumModal.vue?vue&type=script&lang=js&"
export * from "./CategoryForumModal.vue?vue&type=script&lang=js&"
import style0 from "./CategoryForumModal.vue?vue&type=style&index=0&id=1c77528b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports